import ApiClient from '@package/services/src/ApiClient';

import { MenuService } from './interactorTypes';
import { Menu } from './types';

export default class MenuApiService implements MenuService {
  constructor(private apiClient: ApiClient) {}
  public async getMenuData(): Promise<Menu | undefined> {
    try {
      const menuItems = await this.apiClient.get('/main-menu');
      const json = await menuItems.json();
      return json;
    } catch (error) {
      console.error('cant get menu json', error);
    }
  }
}
